import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { CoreBuildingBlock } from '../../shared/building-block.decorator';
import { InputComponent } from '../input/input.component';

/**  Use const due to small list of proper noun */
export const ProperNounPatterns = ['-name', '-city'];
// should be pulled from information.const.ts
const ssnObfuscatedValue = '***-**-****';
const einObfuscatedValue = '**-*******';
const dateObfuscatedValue = '**/**/****';
/** Text box field to display obfuscated value */
@CoreBuildingBlock('input-obfuscate')
@Component({
  selector: 'cu-input-obfuscate',
  styleUrls: ['./input-obfuscate.component.scss'],
  templateUrl: './input-obfuscate.component.html',
  standalone: false
})
export class InputObfuscateComponent extends InputComponent implements OnDestroy, OnInit {
  @ViewChild('input', { static: true }) input!: ElementRef<HTMLInputElement>;

  /** obfuscated Value */
  public obfuscatedValue: string;

  /** child component init method to initialize config obfuscated value  */
  public ngOnInit(): void {
    /** Set the obfuscate value of respective field from config */
    switch (this.field.config.mask) {
      case 'ssn':
        this.obfuscatedValue = ssnObfuscatedValue;
        break;
      case 'ein':
        this.obfuscatedValue = einObfuscatedValue;
        break;
      case 'date':
        this.obfuscatedValue = dateObfuscatedValue;
        break;
      default:
        this.obfuscatedValue = '********';
    }

    /** Call parent method init to set default value */
    super.ngOnInit();
  }

  /** Display temp textbox to display obfuscated value.  */
  public get showObfuscatedValue(): boolean {
    /** If actual textbox value is Valid and its focus is out of this this text, then hide the actual textbox. */
    return this.field.valid && this.field.readableValue !== '' && !this.field.focused;
  }

  /** Display actual textbox to display Unobfuscated value.  */
  public showUnObfuscatedValue(): void {
    this.field.dirty = true;
    if (this.field.focused) {
      this.field.focused = false;
    } else {
      this.field.focused = true;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onMaskFieldKeydown(event: any): boolean {
    /** Allow only Tab key press inside temp obfuscated value textbox. User cannot delete/alter chars. */
    return event && event.keyCode && event.keyCode === 9 ? true : false;
  }
}
